import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import NotFound from 'common/components/layout/404';
import Receipt from 'profile/reservation/ReservationReceipt';
import { getCustomer } from 'redux/customer/actions';
import { getReservationCart } from 'redux/reservationCart/actions';
// import Violator from 'checkout/violator/Violator';
import Availability from 'reservations/availability/Availability';
import Checkout from 'reservations/checkout/Checkout';
import ForgotPassword from 'reservations/login/ForgotPassword';
import Login from 'reservations/login/Login';
import MagicLink from 'reservations/login/MagicLink';
import ReservationType from 'reservations/reservationType/ReservationType';

import CheckoutRoute from './CheckoutRoute';

class ReservationApp extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('reservationCartId')) {
      props.getReservationCart();
    }
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    return (
      <Switch>
        <Route
          exact
          path="/reservation/type/:slug"
          component={ReservationType}
        />
        <Route
          exact
          path="/reservation/availability"
          component={Availability}
        />
        <CheckoutRoute
          exact
          path="/reservation/checkout/login"
          component={Login}
        />
        <CheckoutRoute
          exact
          path="/reservation/checkout/forgot-password"
          component={ForgotPassword}
        />
        <CheckoutRoute
          exact
          path="/reservation/checkout/magic-link"
          component={MagicLink}
        />
        <CheckoutRoute
          exact
          path="/reservation/checkout"
          component={Checkout}
        />
        <CheckoutRoute
          exact
          path="/reservation/checkout/checkout"
          component={Checkout}
        />
        <Route exact path="/reservation/checkout/receipt" component={Receipt} />
        <Route
          exact
          path="/reservation/checkout/receipt/:reservationId"
          component={Receipt}
        />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default connect(null, { getCustomer, getReservationCart })(
  ReservationApp
);
